import { BilikActor } from 'interfaces/events.interface';

export const getBilikUserName = (bilik: BilikActor): string =>
  bilik.givenName || bilik.familyName
    ? `${bilik.givenName ?? ''} ${bilik.familyName?.[0] ?? ''}.`
    : 'Inconnu';
